import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"],
  _excluded2 = ["primary", "danger", "taxfyle", "children", "opposite", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import cx from 'classnames';
import './styles.sass';

/**
 * Dialog title.
 */
export var DialogTitle = function DialogTitle(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('DialogTitle', className)
  }, children);
};
DialogTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export var DialogInfo = function DialogInfo(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('DialogInfo', className)
  }, children);
};
DialogInfo.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

/**
 * Dialog content.
 */
export var DialogContent = function DialogContent(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    other = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('DialogContent', className)
  }, other), children);
};
DialogContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

/**
 * Dialog button.
 */
export var DialogButton = function DialogButton(_ref4) {
  var primary = _ref4.primary,
    danger = _ref4.danger,
    taxfyle = _ref4.taxfyle,
    children = _ref4.children,
    opposite = _ref4.opposite,
    className = _ref4.className,
    other = _objectWithoutProperties(_ref4, _excluded2);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('DialogButton', opposite && 'opposite')
  }, /*#__PURE__*/React.createElement(Button, _extends({
    className: className,
    type: primary ? 'primary' : danger ? 'danger' : taxfyle ? 'taxfyle' : 'default'
  }, other), children));
};
DialogButton.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.bool,
  danger: PropTypes.bool,
  opposite: PropTypes.bool,
  className: PropTypes.string
};

/**
 * Dialog footer. Used to place buttons in.
 * Stuff is aligned to the right using flexbox.
 */
export var DialogFooter = function DialogFooter(_ref5) {
  var children = _ref5.children,
    bordered = _ref5.bordered,
    className = _ref5.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('DialogFooter', className, bordered && 'bordered')
  }, children);
};
DialogFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

/**
 * Dialog.
 */
export var Dialog = function Dialog(_ref6) {
  var children = _ref6.children,
    className = _ref6.className,
    compact = _ref6.compact;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('Dialog', className, compact && 'compact')
  }, children);
};
Dialog.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map
